module.exports = __webpack_public_path__ + "img/Invasion-CRC_10X_TGSP.abf5d527.png";